<template>
  <form-wrapper title="Headings Settings">
    <v-container grid-list-xs>

      <v-layout row wrap>
        <v-flex xs6 px-2 class="mb-5">
          <font-settings
            title="primary (h1) fonts settings"
            :settings.sync="settings.h1"
            ref="h1"
          />
        </v-flex>
        <v-flex xs6 px-2>
          <font-settings
            title="secondary (h2) fonts settings"
            :settings.sync="settings.h2"
            ref="h2"
          />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6 px-2>
          <font-settings
            title="tertiary (h3) fonts settings"
            :settings.sync="settings.h3"
            ref="h3"
          />
        </v-flex>
        <v-flex xs6 px-2>
          <font-settings
            title="quaternary (h4) fonts settings"
            :settings.sync="settings.h4"
            ref="h4"
          />
        </v-flex>
      </v-layout>
    </v-container>

    <reset-submit
      @submit="generateSubmit('heading')"
      @reset="resetSettings"
    />

  </form-wrapper>

</template>

<script>
  import FontSettings from './../styleSettingsFormComponents/FontSettings'
  import FormWrapper from './FormWrapper'
  import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
  import { submitGlobalStyles } from '@/utils/mixins'

  import {
    generateDefaultTextFonts,
    generateMapState
  } from './utils'

  export default {
    name: 'HeadingsSettings',
    components: {
      FontSettings,
      FormWrapper,
      ResetSubmit
    },
    mixins: [submitGlobalStyles],
    data () {
      return {
        settings: {
          h1: generateDefaultTextFonts(33),
          h2: generateDefaultTextFonts(24),
          h3: generateDefaultTextFonts(20),
          h4: generateDefaultTextFonts(34)
        }
      }
    },
    computed: {
      ...generateMapState('heading')
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/HeadingsSettings.vue